// Producao UTB
export const apiUrl = 'https://api.tacom.srv.br/';
export const praca = 'utb';
export const apiLoginUrl = 'https://api.tacom.srv.br/authentication/v1/auth2/login';
export const username = 'utb-web@tacom.com.br';
export const password = 'U@b3w2A';

export const versaoSoftware = '4.4.16';
export const idioma = 'pt_BR'